export const subscriptions = [
  {
    teamLimit: 0,
    price: 0,
    type: 'free',
    teams: 'Free solo'
  },
  {
    teamLimit: 1,
    price: 360,
    type: 'single',
    teams: 'Single team'
  },
  {
    teamLimit: 3,
    price: 720,
    type: 'enterprise',
    teams: '2-3 teams'
  },
  {
    teamLimit: 7,
    price: 1440,
    type: 'enterprise',
    teams: '4-7 teams'
  },
  {
    teamLimit: 15,
    price: 2880,
    type: 'enterprise',
    teams: '8-15 teams'
  },
  {
    teamLimit: 25,
    price: 5500,
    type: 'enterprise',
    teams: '16-25 teams'
  },
  {
    type: 'enterprise',
    teams: '26+ teams'
  },
  {
    teamLimit: 4,
    price: 800,
    type: 'partner',
    teams: '1-4 teams'
  },
  {
    teamLimit: 10,
    price: 1800,
    type: 'partner',
    teams: '5-10 teams'
  },
  {
    teamLimit: 20,
    price: 3800,
    type: 'partner',
    teams: '11-20 teams'
  },
  {
    teamLimit: 50,
    price: 8000,
    type: 'partner',
    teams: '21-50 teams'
  },
  {
    teamLimit: 100,
    price: 16000,
    type: 'partner',
    teams: '51-100 teams'
  },
  {
    type: 'partner',
    teams: '101+ teams'
  },
]

const getSubscriptionTypes = (type) => subscriptions.map((value, id) => ({ id, ...value })).filter(x => x.type === type)

export const free = getSubscriptionTypes('free')
export const single = getSubscriptionTypes('single')
export const enterprise = getSubscriptionTypes('enterprise')
export const partner = getSubscriptionTypes('partner')

export const typePricing = { free, single, enterprise, partner }

export const subscriptionTypes = {
  single: {
    title: 'Single team',
    startingCost: `$${single[0].price}`,
    benefitTitle: 'Features',
    benefits: ['Unlimited seats within a team', 'Run unlimited Squizzes (assessments)', 'Real time results', 'Detailed data and analytics', 'Review progress over time', 'Compare results with our global database']
  },
  enterprise: {
    title: 'Multiple teams',
    startingCost: `$${enterprise[0].price}`,
    benefitTitle: 'Includes single team, plus:',
    benefits: ['Manage teams & members', 'Assign Team Leaders', 'Compare teams within your organization', 'Organizational statistics']
  },
  partner: {
    title: 'Partners',
    description: 'For facilitators, coaches, and integrations',
    benefitTitle: 'Includes everything, plus:',
    benefits: ['Manage clients', 'Access to the Pod&Hive partner facilitator network'],
  }
}

export const isPartner = ({ index } = {}) => subscriptions[index]?.type === 'partner'
export const isFree = ({ index, signupStarted } = {}) => subscriptions[index]?.type === 'free' || signupStarted